import React from 'react';
import EmptyModalContainer from 'app/ui/core/common/EmptyModalContainer';
import './style/Toast.scss';
import Modal from 'react-modal';
import { FOCUS_CHILD, NO_FOCUS } from 'app/ui/config/ThemedFocus';
import { TOAST } from 'app/ui/style/common/zindex';

const ID = 'Toast__Container';

export class ToastContainer extends React.Component {
  render() {
    return (
      <EmptyModalContainer zIndex={TOAST}>
        <div className="Toast__Container" id={ID} />
      </EmptyModalContainer>
    );
  }
}

export default class Toast extends React.Component {
  componentDidMount() {
    this.timeoutId = setTimeout(() => {
      if (this.props.onClose) {
        this.props.onClose();
      }
    }, 10000);
  }

  componentDidUpdate(prevProps) {
    if (!this.props.isOpen && prevProps.isOpen) {
      clearTimeout(this.timeoutId);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutId);
  }

  render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        ariaHideApp={false}
        overlayClassName={{
          base: 'Toast',
          beforeClose: 'Toast--Closing',
          afterOpen: 'Toast--Opened',
        }}
        className={`Toast__Content ${NO_FOCUS}`}
        closeTimeoutMS={950}
        parentSelector={() => document.querySelector(`#${ID}`)}
        role="alertdialog"
      >
        <div className={`Toast__Inner ${FOCUS_CHILD}`}>
          {this.props.children}
        </div>
      </Modal>
    );
  }
}
